export const formatScore = (detail) => {
    if (!detail) {
      return "";
    }
  
    const { VisitorScore, HomeScore } = detail;
  
    if (VisitorScore !== undefined && HomeScore !== undefined) {
      if (VisitorScore === 0 && HomeScore === 0) {
        return "";
      }
  
      return `${VisitorScore} vs ${HomeScore}`;
    }
  
    return "";
  };

  export const formatTeam = (detail) => {
    if (!detail) {
      return "";
    }
  
    const { VisitorScore, HomeScore } = detail;
  
    if (VisitorScore !== undefined && HomeScore !== undefined) {
      if (VisitorScore === "" && HomeScore === "") {
        return "";
      }

      if (VisitorScore === 0 && HomeScore === 0) {
        return "";
      }
  
      return `${VisitorScore} vs ${HomeScore}`;
    }
  
    return "";
  };
  export const formatRAC = (detail) => {
    if(!detail) {
      return "";
    }

    if (detail?.SportDescription == "RAC") {
      return "";
    }

    if (detail?.SportDescription === "" || detail?.LeagueDesc === "") {
      return ""
    }

    return `${detail?.SportDescription} / ${detail?.LeagueDesc}`;
  }

  export const formatDate = (isoDate) => {
    if (!isoDate) return "";
  
    const date = new Date(isoDate);
  
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getUTCMonth()]; 
    const day = date.getUTCDate(); 
    const year = date.getUTCFullYear(); 
  
    let hours = date.getUTCHours(); // Obtiene las horas
    const minutes = String(date.getUTCMinutes()).padStart(2, "0"); 
    const seconds = String(date.getUTCSeconds()).padStart(2, "0"); 
  
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12 || 12; 
  
    return `${month}-${day}, ${year} ${String(hours).padStart(2, "0")}:${minutes}:${seconds}${ampm}`;
  };

  export const dateWithMonthAndTimeString = (originalDate) => {
		if (!originalDate || originalDate === "") return "<never>";

		// Extract the date and time part from the original string
		const dateString = originalDate.substring(0, 19);

		// Create a Date object from the date and time string
		const dateObj = new Date(dateString);

		// Get abbreviated month name
		const monthNames = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];
		const month = monthNames[dateObj.getMonth()];

		// Get the day of the month
		const day = dateObj.getDate();

		// Get the year
		const year = dateObj.getFullYear();

		// Get hours, minutes, and seconds in 12-hour format adjusted for the original format
		let hours = new Date(originalDate).getHours();
		const ampm = hours >= 12 ? "pm" : "am"; // Determine if it's AM or PM
		hours = hours % 12 || 12; // Handle midnight (0 hours) as 12
		hours = hours.toString().padStart(2, "0");
		const minutes = dateObj.getMinutes().toString().padStart(2, "0"); // Get minutes
		const seconds = dateObj.getSeconds().toString().padStart(2, "0"); // Get seconds

		// Final formatted date and time string
		const formattedDate = `${month}-${day}, ${year} ${hours}:${minutes}:${seconds}${ampm}`;

		// Return the formatted date and time string
		return formattedDate;
	}

  export const addCommasNumbers = (nStr) => {

    if (nStr == null || isNaN(nStr)) return '0';

    let num = Number(nStr);

    let x = num.toString().split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1,$2');
    }
    return x1 + x2;
};

export const isValidTransactionType = (transactionType) => {
  const validTransactionTypes = ['W', 'I', 'X', 'O', 'M'];
  return validTransactionTypes.includes(transactionType);
};

export const timeString = (originalDate) => {
  if (!originalDate || originalDate === "") return "<never>";

  const dateObj = new Date(originalDate);

  const hours = dateObj.getHours().toString().padStart(2, "0");
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const seconds = dateObj.getSeconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

export const timeStringWithAmPm = (originalDate) => {
  if (!originalDate || originalDate === "") return "<never>";

  const dateObj = new Date(originalDate);

  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const seconds = dateObj.getSeconds().toString().padStart(2, "0");

  const ampm = hours >= 12 ? "pm" : "am";

  hours = hours % 12 || 12;

  hours = hours.toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds} ${ampm}`;
};
